import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Stack, Tab, Typography } from "@mui/material";
import { useTabActive } from "./context";
import ValueChain from "./ValueChain";
import Tracking from "./Tracking";
import FrequentlyAskedQuestions from "./FrequentlyAskedQuestions";
import ContactUs from "./contact-us/ContactUs";

const TabsHomeView = ({ id, newTheme }) => {
  const { handleChange, value } = useTabActive();
  const tabsData = [
    {
      id: 1,
      label: "زنجیره ارزش آبزیان",
      value: "1",
      content: <ValueChain newTheme={newTheme} />,
      disabled: false,
    },
    {
      id: 2,
      label: "رهگیری در زنجیره",
      value: "2",
      content: <Tracking newTheme={newTheme} />,
      disabled: false,
    },
    {
      id: 3,
      label: "سوالات متداول",
      value: "3",
      content: <FrequentlyAskedQuestions />,
      disabled: true,
    },
    {
      id: 4,
      label: "ارتباط با ما",
      value: "4",
      content: <ContactUs id="contact-us" newTheme={newTheme} />,
      disabled: true,
    },
  ];
  return (
    <>
      <Stack id={id} justifyContent="center" alignItems="center" py={8} display={{ xs: "none", sm: "flex" }}>
        <TabContext value={value}>
          <Box>
            <TabList
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
              TabIndicatorProps={{
                style: {
                  backgroundColor: newTheme.text.color.primary,
                },
              }}
              sx={{
                "& .MuiTabs-flexContainer": {
                  gap: 6,
                },
              }}
            >
              {tabsData.map((tab) => (
                <Tab
                  key={tab?.id}
                  disabled={tab.disabled}
                  label={
                    <Typography variant="subtitle1" fontWeight="fontWeightMedium" color="inherit">
                      {tab.label}
                    </Typography>
                  }
                  value={tab.value}
                  sx={{
                    color: "gray",
                    "&.Mui-selected": {
                      color: newTheme.text.color.primary,
                    },
                    "&.Mui-selected .MuiTypography-root": {
                      color: newTheme.text.color.primary,
                    },
                    "&.Mui-selected::after": {
                      borderBottom: `2px solid ${newTheme.text.color.primary}`,
                    },
                  }}
                />
              ))}
            </TabList>
          </Box>

          {tabsData.map((tab) => (
            <TabPanel
              key={tab?.id}
              value={tab.value}
              sx={{ p: { xs: 0 }, justifyContent: "center", alignItems: "center" }}
            >
              <Stack maxWidth={"900px"} justifyContent={"center"} alignItems={"center"}>
                {tab.content}
              </Stack>
            </TabPanel>
          ))}
        </TabContext>
      </Stack>
      <Stack
        id={id}
        justifyContent="center"
        alignItems="center"
        py={8}
        display={{ xs: "flex", sm: "none" }}
        gap={5}
        flexDirection={"column"}
      >
        {tabsData.map((tab) => (
          <Stack
            maxWidth={"900px"}
            justifyContent={"center"}
            alignItems={"center"}
            p={1}
            display={tab.disabled ? "none" : "flex"}
          >
            {tab.content}
          </Stack>
        ))}
      </Stack>
    </>
  );
};
export default TabsHomeView;
